// extracted by mini-css-extract-plugin
export var contentBody = "_7g-9";
export var headerImage = "_7g-2";
export var imageButton = "_7g-7";
export var imageButtonIcon = "_7g-8";
export var imageHeader = "_7g-4";
export var imageHeaderText = "_7g-5";
export var imageOverlay = "_7g-3";
export var imageTitle = "_7g-6";
export var imageWrapper = "_7g-1";
export var taskList = "_7g-a";
export var widget = "_7g-0";